import { GoalDirection } from './types';

export const getGoalDirectionWords = (goalDirection: GoalDirection) => {
    return (
        {
            DEPOSIT: { noun: 'deposit', verb: 'deposit', gerund: 'depositing' },
            WITHDRAWAL: {
                noun: 'withdrawal',
                verb: 'withdraw',
                gerund: 'withdrawing',
            },
            GOAL_TO_GOAL: {
                noun: 'transfer',
                verb: 'transfer',
                gerund: 'transferring',
            },
        } as const
    )[goalDirection];
};
